import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { HeartBeatStatus } from '@Types/heartBeatDetails.types';

const createActionName = (...p: string[]) => p.join('/');

const ACTION_CONTEXT = 'heartBeat';
const GET_STATUS = 'getHeartBeatStatus';
const POLL_STATUS = 'pollHeartBeatStatus';
const SYNC = 'sync';

export const restoreHeartBeatStatusStore = createAction(
	addNamespace(createActionName(ACTION_CONTEXT, 'resetStatusStore')),
);

export type GetHeartBeatStatusPayload = {
	pollDelaySec: number;
	stopAfterSec?: number; // ? if not provided polling won't stop
};
export const getHeartBeatStatus = createAction<GetHeartBeatStatusPayload>(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS)),
);

export const getHeartBeatStatusResolved = createAction<HeartBeatStatus>(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS, 'resolved')),
);
export const getHeartBeatStatusRejected = createAction(
	addNamespace(createActionName(ACTION_CONTEXT, GET_STATUS, 'rejected')),
);

export const pollHeartBeatStatusStop = createAction(
	addNamespace(createActionName(ACTION_CONTEXT, POLL_STATUS, 'stop')),
);

export const setHeartBeatStatusSyncCount = createAction<number>(
	addNamespace(createActionName(ACTION_CONTEXT, POLL_STATUS, SYNC, 'reset')),
);
